module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabGrid"
  }, [_c('a', {
    staticClass: "cell",
    on: {
      "click": _vm.click1
    }
  }, [_c('div', {
    staticClass: "cellContent",
    class: _vm.active1 === true ? 'active' : 'inactivated'
  }, [_c('i', {
    staticClass: "icon iconsize"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("首页")])])]), _vm._v(" "), _c('a', {
    staticClass: "cell",
    on: {
      "click": _vm.click2
    }
  }, [_c('div', {
    staticClass: "cellContent",
    class: _vm.active2 === true ? 'active' : 'inactivated'
  }, [_c('i', {
    staticClass: "icon iconsize"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("我的")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f55d6608!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/tab.vue
// module id = 893
// module chunks = 34